import React from "react";
import ProjectCard from "./ProjectCard";
import todoly from "./../assets/todoly.png";
import { Link, Element } from "react-scroll";
import appImage from "./../assets/app-react-edited.png";
import tictactoegraphic from "./../assets/tictactoe_graphic.png"



export default function Projects() {
  return (
    <Element name="projects">
      <div className="flex flex-col items-center text-center gap-20 sm:gap-12 max-w-[2500px]">
        <div className="flex gap-4 flex-col">
          <p className="text-3xl font-bold">Projects</p>
          <p className="text-xl">Some projects I've built</p>
          <hr className="border-0 h-1 bg-green-500 w-4/5 mx-auto mb-4" />
        </div>

        <div className="w-full grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-24">


           <ProjectCard
            image={tictactoegraphic}
            title="Websocket Tic Tac Toe"
            summary="A microservices-based Tic-Tac-Toe game with API Gateway for routing and authentication, User Service for profiles and stats, Matchmaking Service for game creation and notifications, and Game Service for real-time gameplay and WebSocket communication. Redis ensures efficient session and state management."
            tech={['spring','react', 'redis', 'psql']}
            githubLink='https://github.com/moe399/tic-tac-toe-websocket'
            link='http://168.119.239.66:3000/'
        />


          <ProjectCard
            
            image={appImage}
            title="Delivery Route Optimisation App"
            summary="Built with React Native and Mapbox, this app streamlines delivery routes by optimising addresses via the Mapbox Optimization API. Key features include multiple parcel assignments, parcel photo attachments, and a custom algorithm to match coordinates to addresses. It improved my skills in route optimisation and full-stack development."
            tech={['react']}
            githubLink='https://github.com/moe399/navigation-app'
          />
          <ProjectCard
            image={todoly}
            title="Todoly"
            summary="A full stack CRUD Todo app built with PocketBase for backend and Next.js for frontend. I learned API integration, managing data flow, handling authentication, and performing full CRUD operations efficiently across both server and client."
            tech={['react']}
            githubLink='https://github.com/moe399/todoApp'
            link='https://todo-app-ebon-theta-48.vercel.app/'

          />


        </div>
      </div>
    </Element>
  );
}
